module.exports = __webpack_public_path__ + "static/media/tw.9374cc29.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tw.svg
// module id = 1055
// module chunks = 0